<script>
import Button from "./Button.svelte"

export let draft = false
</script>

<Button {...$$restProps} type="submit" draft="{draft}" />
